import ContentPage from "../../content/ContentPage";
import Track from "../../core/instrumentation";
import { Accommodation, Page } from "../../resources/modelTypes";
import React, { useCallback } from "react";

export type TravelProps = {
  accommodations: Accommodation[];
  configuration: {
    imageAlignment: string;
    imageSize: number;
    pageLayout: string;
    showMap: boolean;
    textAlignment: string;
  };
  id: string;
  pageData: Page;
  title: string;
};

const Travel = ({
  accommodations,
  configuration,
  id,
  pageData,
  title,
}: TravelProps) => {
  const actionLinkHandler = useCallback(
    () =>
      Track.emit({
        event: "Travel_Visit_URL_clicked",
        feature: "View Travel & Accommodations",
      }),
    [],
  );

  return (
    <ContentPage
      actionLinkProps={{
        onClick: actionLinkHandler,
        text: "Visit Website",
      }}
      configuration={configuration}
      data={accommodations}
      id={id}
      pageData={pageData}
      title={title}
    />
  );
};

export default Travel;
